export default __webpack_public_path__ + "static/media/ontrack.4d5d76fe.md";